import { Map, List } from 'immutable';
import {
  FETCH_RAV2_HOMEWORK_RESULT_DETAIL_SUCCESS,
} from './actions';
import StudentHomeworkDetail from './model';

export default function rav2HomeworkResultDetail(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_RAV2_HOMEWORK_RESULT_DETAIL_SUCCESS:
      return state.set(action.groupId, toGroupDetailList(action.payload));
    default:
      return state;
  }
}

function toGroupDetailList(payload) {
  const list = normalizePayload(payload);

  return new List(
    list
      .filter((item) => item && item.studentGeneralInfo && item.studentGeneralInfo.id)
      .map((item) => StudentHomeworkDetail.create({
        studentId: item.studentGeneralInfo.id,
        studentGeneralInfo: item.studentGeneralInfo,
        unitResults: item.unitResults || [],
        status: item.status,
        isInProduction: item.isInProduction,
      }))
  );
}

function normalizePayload(payload) {
  if (! payload) {
    return [];
  }

  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload.data)) {
    return payload.data;
  }

  if (Array.isArray(payload.items)) {
    return payload.items;
  }

  return [];
}



// WEBPACK FOOTER //
// ./data/RAv2HomeworkResultDetail/reducer.js